"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var expressionItemStyles = styles_1.makeStyles(function () { return ({
    container: {
        padding: '2px 0',
    },
}); }, { name: 'GqlSummary_ExpressionItem' });
exports.default = expressionItemStyles;
